import { createContext } from "react";
import { Toast, ToastToAdd, ToastToRemove } from "./types";

type NotificationContextType = {
  activeToasts: Toast[];
  addToasts: (toastsToAdd: ToastToAdd[]) => void;
  removeToasts: (toastsToRemove: ToastToRemove[]) => void;
};

export const NotificationContext = createContext<NotificationContextType>({
  activeToasts: [],
  addToasts: () => {},
  removeToasts: () => {},
});
